import { Pipe, PipeTransform } from '@angular/core';
import { ReportCardGradesTerm } from '../grades.model';

@Pipe({
  name: 'standardsBasedGradesFilter'
})
export class StandardsBasedGradesFilterPipe implements PipeTransform {

  transform(reportCardGradesTerms: ReportCardGradesTerm[], header: ReportCardGradesTerm): any {
    return reportCardGradesTerms.filter(o => o.GradingTerm == header.GradingTerm);
  }
}
